import Client from './HttpClient';

const baseUrl = '/gateway/echidna-api/api/vs';

const login = (email, password) => {
	return Client.post(`${baseUrl}/user/merchant/login`, {
		loginCode: email,
		pwd: password,
	});
};

// Type: 1 邮箱 / 2 手机号
// Scene: 1 登录，2 找回登录密码 3，绑定账户 4，更换密码，5，前端验证码
const sendValidationCode = (loginCode, type, scene) => {
	return Client.post(`${baseUrl}/user/verification-code`, {
		loginCode,
		type,
		scene,
	});
};

const changePassword = (password, newPassword) => {
	return Client.post(`${baseUrl}/user/update-pwd`, {
		oldPwd: password,
		pwd: newPassword,
	});
};

const bindMobile = (phone, verifyCode, region = 1) => {
	return Client.post(`${baseUrl}/user/binding-phone`, {
		phoneRegion: region, // 手机所属地区(1--61,2--86)
		phone,
		verifyCode,
	});
};

const resetPassword = (email, password, verifyCode) => {
	return Client.post(`${baseUrl}/user/forget-pwd`, {
		email,
		password,
		verifyCode,
	});
};

const getProfile = (token = '') => {
	return Client.get(
		`${baseUrl}/user/detail`,
		{},
		{
			headers: {
				Token: token,
			},
		}
	);
};

const getAssignments = (token = '', application = 'merchant-portal') => {
	return Client.get(
		`${baseUrl}/resource/${application}`,
		{},
		{
			headers: {
				Token: token,
			},
		}
	);
};

const getRolesAndPermissions = () => {
	return Client.get(`${baseUrl}/resource/tob-user-auth`);
};

const uploadAvatar = (file) => {
	const formData = new FormData();
	formData.append('file', file);
	return Client.post(
		`${baseUrl}/user/upload-img`,
		formData,
		{},
		{
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		}
	);
};

const changeNickname = (nickName) => {
	return Client.post(`${baseUrl}/user/nick-name`, {
		nickName,
	});
};

const changePhone = (phone, verifyCode, originVerifyCode, region = 1) => {
	return Client.post(`${baseUrl}/user/modify-phone`, {
		phoneRegion: region,
		phone,
		verifyCode,
		originVerifyCode,
	});
};

const getMenu = (application = 'merchant-portal') => {
	return Client.get(`${baseUrl}/resource/menu/${application}`);
};

const getPermissions = (userId) => {
	return Client.get(`${baseUrl}/resource/user/${userId}`);
};

const getRoles = () => {
	return Client.get(`${baseUrl}/resource/tob-role`);
};

const sso = (payload) => {
	return Client.post(`${baseUrl}/user/online-order/goto`, payload);
};

export default {
	login,
	getRolesAndPermissions,
	getMenu,
	sendValidationCode,
	bindMobile,
	changePassword,
	resetPassword,
	getProfile,
	uploadAvatar,
	changeNickname,
	changePhone,
	getAssignments,
	getPermissions,
	getRoles,
	sso,
};
